import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyle from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        borderLeft: `1px solid ${sicrediStyle.secondarySicrediLight}`,
        backgroundColor: 'white',
        width: 'calc(100% - 353px)',
        height: 'calc(100% - 110px)',
        overflow: 'hidden',
      },
      noChat: {
        display: 'flex',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: sicrediStyle.secondarySicrediLight,
        '& svg': {
          fontSize: 64,
          marginBottom: 16,
        },
      },
      conversa: {
        flex: 'auto',
        width: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
      },
      duvida: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: `16px 0`,
        boxSizing: 'border-box',
      },
      respondida: {
        backgroundColor: '#f8f9f7',
      },
      duvidaData: {
        width: '100%',
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'left',
        color: sicrediStyle.secondarySicrediDark,
        padding: 8,
        boxSizing: 'border-box',
      },
      pergunta: {
        flex: 'auto',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        padding: 16,
        boxSizing: 'border-box',
        backgroundColor: sicrediStyle.primarySicredi,
      },
      perguntaText: {
        flex: 'auto',
        color: 'white',
        fontSize: 16,
        fontWeight: 300,
        padding: 16,
        boxSizing: 'border-box',
      },
      perguntaPublic: {
        flex: 'none',
        color: sicrediStyle.primarySicrediDark,
        backgroundColor: sicrediStyle.primarySicrediLight,
        textTransform: 'none',
        fontSize: 12,
      },
      perguntaPrivate: {
        flex: 'none',
        color: sicrediStyle.warningSicrediDark,
        backgroundColor: sicrediStyle.warningSicrediLight,
        textTransform: 'none',
        fontSize: 12,
      },
      respostaData: {
        width: '100%',
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'right',
        color: sicrediStyle.secondarySicrediDark,
        padding: 8,
        boxSizing: 'border-box',
      },
      resposta: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        maxWidth: '70%',
        boxSizing: 'border-box',
        backgroundColor: sicrediStyle.secondarySicrediLight,
        borderRadius: '10px 10px 0 10px',
        alignSelf: 'flex-end',
        marginRight: 16,
      },
      respostaText: {
        flex: 'auto',
        textAlign: 'left',
        fontSize: 16,
        fontWeight: 300,
        color: sicrediStyle.secondarySicrediDarker,
        padding: 8,
        boxSizing: 'border-box',
      },
      editarResposta: {
        flexShrink: 0,
        backgroundColor: '#5a645a',
        textTransform: 'none',
        color: 'white',
        fontSize: 12,
        margin: 8,
      },
      responder: {
        alignSelf: 'flex-end',
        margin: `8px 16px`,
        color: sicrediStyle.primarySicrediDark,
        backgroundColor: sicrediStyle.primarySicrediLight,
        textTransform: 'none',
        fontSize: 12,
      },
      buttonIcon: {
        width: 16,
        height: 16,
      },
      input: {
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: 100,
        borderTop: `1px solid ${sicrediStyle.secondarySicrediLight}`,
        boxSizing: 'border-box',
        transformOrigin: 'center bottom',
        transform: 'scaleY(0)',
      },
      inputDuvida: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        flexShrink: 0,
        backgroundColor: '#f8f9f7',
        borderBottom: `1px solid ${sicrediStyle.secondarySicrediLight}`,
        boxSizing: 'border-box',
        overflow: 'hidden',
        padding: `0 16px`,
      },
      inputDuvidaText: {
        flex: 'auto',
        lineHeight: '38px',
        overflow: 'hidden',
        fontSize: 16,
        fontWeight: 300,
        color: sicrediStyle.secondarySicrediDarker,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      cancelarResposta: {
        flexShrink: 0,
        fontSize: 12,
      },
      textField: {
        boxSizing: 'border-box',
        height: '100%',
        '& .MuiInputBase-root': {
          padding: '8px 16px',
          boxSizing: 'border-box',
        },
      },
      endAdornment: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
      counter: {
        fontSize: 12,
        color: sicrediStyle.secondarySicredi,
      },
      submitIcon: {
        fontSize: 16,
      },
      backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: 24,
      },
      backdropOpen: {
        pointerEvents: 'all',
      },
      paper: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        transitionProperty: 'transform, opacity',
        transitionDuration: '200ms, 150ms',
        transitionTimingFunction: 'cubic-bezier(0.4, 0.0, 1, 1)',
        transformOrigin: 'top right',
        transform: 'scale(0)',
        maxWidth: 280,
        opacity: 0,
      },
      paperOpen: {
        transitionTimingFunction: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
        transform: 'scale(1)',
        opacity: 1,
      },
    }),
  { name: 'ChatAssessor' }
);
